/* Video players for the swatch product page (4 Oct 2026): sections/spw-pdp-videos.liquid and spw-pdp-features.liquid.
   Silent loops (video[data-spwm-loop]) get their source only when they first come near the screen, play while
   visible and pause when not. A Slouch effect card (button[data-spwm-full]) plays its full clip with sound on tap.
   Safe to load more than once: the print switcher re-inserts these sections. */
(function () {
  'use strict';
  if (window.SPWMedia) { window.SPWMedia.scan(); return; }
  // Safari (every iPhone) plays Shopify's adaptive stream natively: it starts at a small size and sharpens, so loops
  // appear almost at once. Other browsers get the MP4.
  // Desktop/Android Chrome also claims HLS support but stalls on some streams, so it keeps the MP4 (window.chrome).
  var HLS = !!document.createElement('video').canPlayType('application/vnd.apple.mpegurl') && !window.chrome;
  var loopSrc = function (v) { return (HLS && v.dataset.spwmHls) || v.dataset.spwmLoop; };
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (v.dataset.spwmSound) return; // the shopper is watching it with sound: leave it alone
      if (e.isIntersecting) {
        if (!v.getAttribute('src')) v.src = loopSrc(v);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) v.pause();
    });
  }, { rootMargin: '200px 0px', threshold: 0.2 }) : null;

  function scan() {
    document.querySelectorAll('video[data-spwm-loop]:not([data-spwm-on])').forEach(function (v) {
      v.setAttribute('data-spwm-on', '');
      v.addEventListener('playing', function () { v.classList.add('is-on'); });
      if (io) io.observe(v); else { v.src = loopSrc(v); v.autoplay = true; }
    });
  }

  function stop(card) {
    var v = card.querySelector('video');
    card.classList.remove('is-sound');
    if (v && v.dataset.spwmSound) {
      delete v.dataset.spwmSound;
      v.muted = true; v.loop = true; v.controls = false;
      v.src = loopSrc(v); var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
  }
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-spwm-full]');
    if (!card) return;
    var v = card.querySelector('video'), full = (HLS && card.dataset.spwmFullHls) || card.dataset.spwmFull;
    if (!v || !full) return;
    if (v.dataset.spwmSound) { if (v.paused) v.play(); else v.pause(); return; }
    document.querySelectorAll('.is-sound[data-spwm-full]').forEach(stop);
    v.dataset.spwmSound = '1'; card.classList.add('is-sound');
    v.loop = false; v.muted = false; v.src = full;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    v.onended = function () { stop(card); };
  });

  window.SPWMedia = { scan: scan };
  scan();
  document.addEventListener('spw:sections-swapped', scan);
})();
